import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import './EntrepriseQuotes.css'; // Reuse common styles

const API_URL = import.meta.env.VITE_API_URL;

const EntrepriseInvoices = () => {
    const [factures, setFactures] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchFactures();
    }, []);

    const fetchFactures = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_URL}/documents-financiers/mes-factures`, {
                headers: {Authorization: `Bearer ${token}`}
            });
            setFactures(response.data.factures || []);
        } catch (error) {
            console.error('Erreur factures:', error);
            // Non-critical if no endpoint yet
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="entreprise-quotes-container">
            <div className="ent-section-header">
                <h2>Mes Factures B2B</h2>
                <p>Consultez et téléchargez vos documents financiers et factures acquittées.</p>
            </div>

            {loading ? (
                <LoadingSpinner message="Récupération des factures..." />
            ) : factures.length === 0 ? (
                <div className="empty-state">
                    <span className="empty-icon">🧾</span>
                    <h3>Aucune facture disponible</h3>
                    <p>Vos factures apparaîtront ici après la validation de vos premières commandes.</p>
                </div>
            ) : (
                <div className="quotes-grid">
                    {factures.map((facture) => (
                        <div key={facture._id} className="quote-card">
                            <div className="quote-card-header">
                                <span className="quote-type-tag">FACTURE</span>
                                <span className="status-badge success">ACQUITTÉE</span>
                            </div>
                            <div className="quote-main-info">
                                <span className="quote-id">#{facture.numeroFacture || facture._id.substring(0, 8).toUpperCase()}</span>
                                <span className="quote-date">{new Date(facture.createdAt).toLocaleDateString()}</span>
                            </div>
                            <div className="quote-specs">
                                <div className="spec-item">
                                    <span>Montant HT:</span>
                                    <strong>{facture.montantHT || 0} DT</strong>
                                </div>
                                <div className="spec-item">
                                    <span>TVA:</span>
                                    <strong>{facture.montantTVA || 0} DT</strong>
                                </div>
                                <div className="spec-item">
                                    <span>Total TTC:</span>
                                    <strong>{facture.montantTTC || 0} DT</strong>
                                </div>
                            </div>
                            <button
                                className="view-details-btn"
                                onClick={() => Swal.fire('Téléchargement', 'Le PDF de la facture est en cours de génération...', 'info')}
                            >
                                Télécharger PDF
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default EntrepriseInvoices;
